import { Fixture as FixtureNg } from "../TeamOverview/TeamOverviewModels";

export const THE_GAME_ROUND_TYPE_PREFIX = "TheGame-";
export const THE_GAME_MANIFEST_KEY = "THE_GAME";
export const THE_GAME_STANDINGS_KEY = "THE_GAME_STANDINGS";
export const THE_GAME_JACKPOT_KEY = "jackpotEUR";
// bogateway-ng only builds the corners and cards markets for this round type.
export const THE_GAME_ROUND_TYPE_WITH_CORNERS_AND_CARDS = "TheGame-8";

// Body of bogateway-ng POST the-game/rounds/test.
export interface TheGameRoundTestCreateRequest {
    roundTypeName: string;
    fixtureId: number;
    player1: string;
    player2: string;
    jackpotEUR?: number;
    overUnderLine: number;
    overUnderHTLine: number;
    cornersOverUnderLine?: number;
    cardsOverUnderLine?: number;
}

// Only the part of the bogateway-ng RoundEntry that the page shows.
export interface TheGameRoundEntry {
    id: string;
    roundTypeName: string;
    status: string;
    openTo: string;
    fixtures: FixtureNg[] | null;
    promotionValues: RoundPromotionValue[] | null;
    resultUpdateMode?: string;
    // Index i lines up with fixtures[i] and the manifest market with pos i.
    fixtureResults?: FixtureResult[] | null;
    correctRow?: string[] | null;
    preliminaryCorrectRow?: string[] | null;
}

// sign is the roundservice name: ONE, X or TWO.
export interface FixtureResult {
    status: string;
    sign: string;
    drawId?: string | null;
}

// The THE_GAME promotion value.
export interface TheGameManifest {
    match: TheGameManifestMatch;
    markets: TheGameManifestMarket[];
}

export interface TheGameManifestMatch {
    fixtureId: number;
    home: string;
    away: string;
    kickoff: string;
}

// marketTypeId: 1 Match Odds FT, 2 Match Odds HT, 3 O/U goals FT, 4 O/U goals HT, 5 Player scores FT,
// 6 Corners O/U FT, 7 Cards O/U FT. selections maps sign (1, X, 2) to its label; 2-way markets have no 2.
export interface TheGameManifestMarket {
    pos: number;
    marketTypeId: number;
    label: string;
    line?: number | null;
    selections: Record<string, string>;
}

// Body and response of bogateway-ng the-game/rounds/{id}/standings; updatedAt is missing on a generated default.
export interface TheGameStandings {
    updatedAt?: string | null;
    markets: TheGameStandingsMarket[];
}

export interface TheGameStandingsMarket {
    pos: number;
    sign: string;
    decided: boolean;
    note?: string | null;
}

export interface RoundPromotionValue {
    id: string;
    roundId: string;
    key: string;
    value: string;
}
